import {
  createBatchEntryStore,
  createPendingDraftHelpers,
  type StorageAdapter,
} from '@pantry/shared-react/stores';

/**
 * localStorage-backed StorageAdapter for web.
 */
const localStorageAdapter: StorageAdapter = {
  getItem: (key) => {
    if (typeof window === 'undefined') return null;
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem: (key, value) => {
    if (typeof window === 'undefined') return;
    try {
      localStorage.setItem(key, value);
    } catch {
      // Ignore quota errors
    }
  },
  removeItem: (key) => {
    if (typeof window === 'undefined') return;
    try {
      localStorage.removeItem(key);
    } catch {
      // Ignore errors
    }
  },
};

export const useBatchEntryStore = createBatchEntryStore(localStorageAdapter);

const helpers = createPendingDraftHelpers(localStorageAdapter);

/**
 * Check if there's a pending draft in localStorage.
 * Delegates to the shared helper for consistent validation logic.
 */
export const getPendingDraft = helpers.getPendingDraft;

/**
 * Clear any pending draft from localStorage.
 * Async because it delegates to the shared helper (uniform across platforms).
 */
export const clearPendingDraft = helpers.clearPendingDraft;
